import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Alert } from "flowbite-react";
import LojaForm from "./LojaForm";
import LojaLinksManager from "./LojaLinksManager";
import { atualizarLojaAction, loadLoja } from "../../actions/user";
import { showNotification } from "../../actions/notification";
import { hasPlanAccess } from "../../utils/subscription";

const EditLoja = () => {
  const dispatch = useDispatch();
  const { loja, profile } = useSelector((state) => state.user);
  const assinaturaAtiva = hasPlanAccess(profile);

  const [lojaForm, setLojaForm] = useState({
    nome_fantasia: "",
    slogan: "",
    profile_picture: null,
    pixel_meta_id: "",
    pixel_meta_access_token: "",
    pixel_meta_test_event_code: "",
    seo_title: "",
    seo_description: "",
    seo_keywords: "",
    custom_head_code: "",
    layout_card_produto: "classico",
  });

  useEffect(() => {
    setLojaForm({
      nome_fantasia: loja?.nome_fantasia || "",
      slogan: loja?.slogan || "",
      profile_picture: loja?.profile_picture || null,
      pixel_meta_id: loja?.pixel_meta_id || "",
      pixel_meta_access_token: loja?.pixel_meta_access_token || "",
      pixel_meta_test_event_code: loja?.pixel_meta_test_event_code || "",
      seo_title: loja?.seo_title || "",
      seo_description: loja?.seo_description || "",
      seo_keywords: loja?.seo_keywords || "",
      custom_head_code: loja?.custom_head_code || "",
      layout_card_produto: loja?.layout_card_produto || "classico",
      updatedAt: loja?.updatedAt || loja?.updated_at || null,
    });
  }, [loja]);

  const handleLojaChange = (e) => {
    const { name, value } = e.target;
    setLojaForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleProfilePictureUpdate = (blob) => {
    setLojaForm((prevForm) => ({
      ...prevForm,
      profile_picture: blob,
    }));
  };

  const handleSubmitLoja = (e) => {
    e.preventDefault();
    if (!assinaturaAtiva) return;
    dispatch(atualizarLojaAction(lojaForm));
  };

  return (
    <div className="relative isolate backdrop-blur-none px-6 lg:px-8">
      <div className="mx-auto max-w-3xl py-16 sm:py-20 lg:py-24">
        <h1 className="text-3xl font-bold tracking-tight text-center text-gray-900 sm:text-4xl">
          Editar Loja
        </h1>

        {!assinaturaAtiva ? (
          <div className="mt-6">
            <Alert color="warning">
              Seu plano esta inativo. As alteracoes da loja ficam bloqueadas ate
              reativar em <b>/app/planos</b>.
            </Alert>
          </div>
        ) : null}

        <LojaForm
          lojaForm={lojaForm}
          handleLojaChange={handleLojaChange}
          handleSubmitLoja={handleSubmitLoja}
          profilePicture={lojaForm.profile_picture}
          onProfilePictureUpdate={handleProfilePictureUpdate}
          canEdit={assinaturaAtiva}
          section="basic"
        />

        <LojaLinksManager
          canEdit={assinaturaAtiva}
          onChanged={() => dispatch(loadLoja())}
          notify={(payload) => dispatch(showNotification(payload))}
        />

        <LojaForm
          lojaForm={lojaForm}
          handleLojaChange={handleLojaChange}
          handleSubmitLoja={handleSubmitLoja}
          profilePicture={lojaForm.profile_picture}
          onProfilePictureUpdate={handleProfilePictureUpdate}
          canEdit={assinaturaAtiva}
          section="seo"
        />
      </div>
    </div>
  );
};

export default EditLoja;
